module.exports = __webpack_public_path__ + "bootleggers_coffee_font03.jpg?d6929be02bf2ac6a9d82e70a0060dd54";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggers_coffee_font03.jpg
// module id = 37
// module chunks = 0